module.exports = __webpack_public_path__ + "assets/01.a1a8e6b5.pdf";